<template>
    <div>
        <van-divider>基本信息</van-divider>
        <van-form ref="basicInfoForm" >
            <van-field label="申请人"
                       placeholder="请填写申请人姓名"
                       v-model="assistance.applyName"
                       :rules="[{ required:true, message: '请填写申请人姓名' }]"
            />
            <van-field
                    label="身份证号"
                    placeholder="请填写申请人身份证号"
                    v-model="assistance.applyIDNum"
                    :rules="[{ validator:idCardValidator, message: '请输入正确身份证号' }]"
            />

            <van-field label="电话"
                       placeholder="请填写联系电话"
                       v-model="assistance.phone"
                       :rules="[{pattern:/^1[3456789]\d{9}$/, required:true, message: '联系电话' }]"
            />
            <van-field name="gender" label="性别">
                <template #input>
                    <van-radio-group v-model="assistance.sex" direction="horizontal">
                        <van-radio :name="1">男</van-radio>
                        <van-radio :name="2">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                    readonly
                    clickable
                    name="birthday"
                    :value="assistance.birthday"
                    label="生日"
                    placeholder="请选择生日"
                    @click="showBirthDayPicker = true"
                    :rules="[{ required:true, message: '请选择生日' }]"
            />

            <van-field label="职业"
                       placeholder="请填写职业"
                       v-model="assistance.professional"
                       :rules="[{ required:true, message: '请填写职业' }]"
            />
            <van-field
                    readonly
                    clickable
                    name="national"
                    :value="assistance.national"
                    label="民族"
                    placeholder="请选择民族"
                    @click="showNationalPicker = true"
                    :rules="[{ required:true, message: '请选择民族' }]"
            />

            <van-field label="住址所在地"
                       placeholder="请填写住址"
                       v-model="assistance.address"
                       type="textarea"
                       autosize
                       :rules="[{ required:true, message: '请填写住址' }]"
            />
            <van-field label="案情"
                       placeholder="请填写案情"
                       v-model="assistance.theCase"
                       type="textarea"
                       rows="3"
                       autosize
                       maxlength="500"
                       show-word-limit
                       :rules="[{ required:true, message: '请填写案情' }]"
            />

        </van-form>
        <van-divider>身份证</van-divider>

        <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
            <div style="margin: 5px 10px;display: flex;flex-direction: column;align-items: center;justify-content: center" >
                <div  v-if="assistance.idCardImgA" style="width: 80px;height: 80px;position: relative;">
                    <img :src="assistance.idCardImgA" width="100%" height="100%" style="object-fit: cover;border-radius: 4px;"  @click="showImage(assistance.idCardImgA)"/>
                    <van-icon
                            name="clear"
                            size="17"
                            color="#969799"
                            style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                            @click="assistance.idCardImgA=undefined"
                    />
                </div>
                <van-uploader
                        v-else
                        v-model="IDCardFrontFile"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'idCardImgA')"
                        :delete="()=>deleteImage('idCardImgA')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
                <div style="color: #969799;font-size: 14px;margin-top: 10px;">身份证正面</div>
            </div>
            <div style="margin: 5px 10px;display: flex;flex-direction: column;align-items: center;justify-content: center">
                <div  v-if="assistance.idCardImgB" style="width: 80px;height: 80px;position: relative;">
                    <img  width="100%" height="100%" :src="assistance.idCardImgB" style="object-fit: cover;border-radius: 4px;"  @click="showImage(assistance.idCardImgB)"/>
                    <van-icon
                            name="clear"
                            color="#969799"
                            size="17"
                            style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                            @click="assistance.idCardImgB=undefined"
                    />
                </div>
                <van-uploader
                        v-else
                        v-model="IDCardBackFile"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'idCardImgB')"
                        :delete="()=>deleteImage('idCardImgB')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
                <div style="color: #969799;font-size: 14px;margin-top: 10px;">身份证背面</div>
            </div>
        </div>

        <van-divider>其他资料（可选）</van-divider>
        <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;flex-wrap: wrap;">

            <div  v-if="assistance.img1" style="width: 80px;height: 80px;position: relative;margin: 5px 10px;">
                <img  width="100%" height="100%" :src="assistance.img1" style="object-fit: cover;border-radius: 4px;" @click="showImage(assistance.img1)"/>
                <van-icon
                        name="clear"
                        color="#969799"
                        size="17"
                        style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                        @click="appendixClearClick(1)"
                />
            </div>
            <div  v-if="assistance.img2" style="width: 80px;height: 80px;position: relative;margin: 5px 10px;">
                <img  width="100%" height="100%" :src="assistance.img2" style="object-fit: cover;border-radius: 4px;" @click="showImage(assistance.img2)"/>
                <van-icon
                        name="clear"
                        color="#969799"
                        size="17"
                        style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                        @click="appendixClearClick(2)"
                />
            </div>
            <div  v-if="assistance.img3" style="width: 80px;height: 80px;position: relative;margin: 5px 10px;">
                <img  width="100%" height="100%" :src="assistance.img3" style="object-fit: cover;border-radius: 4px;" @click="showImage(assistance.img3)"/>
                <van-icon
                        name="clear"
                        color="#969799"
                        size="17"
                        style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                        @click="appendixClearClick(3)"
                />
            </div>
            <div  v-if="assistance.img4" style="width: 80px;height: 80px;position: relative;margin: 5px 10px;">
                <img  width="100%" height="100%" :src="assistance.img4" style="object-fit: cover;border-radius: 4px;" @click="showImage(assistance.img4)"/>
                <van-icon
                        name="clear"
                        color="#969799"
                        size="17"
                        style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                        @click="appendixClearClick(4)"
                />
            </div>
            <div  v-if="assistance.img5" style="width: 80px;height: 80px;position: relative;margin: 5px 10px;">
                <img  width="100%" height="100%" :src="assistance.img5" style="object-fit: cover;border-radius: 4px;" @click="showImage(assistance.img5)"/>
                <van-icon
                        name="clear"
                        color="#969799"
                        size="17"
                        style="position: absolute;top: -8px;right: -8px;font-size: 18px; background-color: #fff; border-radius: 100%;"
                        @click="appendixClearClick(5)"
                />
            </div>
            <van-uploader
                    v-if="!assistance.img5"
                    multiple
                    v-model="appendix"
                    :afterRead="(file)=>afterReadAppendix(file)"
                    :delete="()=>deleteImageAppendix"
            >
                <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
            </van-uploader>

        </div>

        <van-button round block slot="button" style=" width: 100%" type="primary" @click="submit">提交</van-button>

        <van-popup v-model="showBirthDayPicker" position="bottom">
            <van-datetime-picker
                    type="date"
                    @confirm="onPickBirthDay"
                    @cancel="showBirthDayPicker = false"
            />
        </van-popup>

        <van-popup v-model="showNationalPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="nationals"
                    @confirm="onPickNational"
                    @cancel="showNationalPicker = false"
            />
        </van-popup>
        <van-overlay
                :show="showImageOverlay"
                @click="showImageOverlay = false"
                style = "display: flex;justify-content: center;align-items: center"
        >
            <img :src="overlayImageUrl" width="90%">
        </van-overlay>
    </div>
</template>

<script>
  import ClipboardJS from 'clipboard'
  import {Toast} from 'vant'
  import axios from 'axios'
  import moment from 'moment';
  import {responseCodes,consultStatus,userTypes} from '../../common/const'
  import COS from 'cos-js-sdk-v5'
  export default {
    name: "Assistance",
    data() {
      return {
        assistance:this.$route.params.assistance,
        showNationalPicker:false,
        showBirthDayPicker:false,
        showImageOverlay:false,
        overlayImageUrl:'',
        idCard18Pattern:/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/,
        idCard15Pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        IDCardFrontFile:[],
        IDCardBackFile:[],
        appendix:[],
        nationals:['汉族','蒙古族','回族','藏族','维吾尔族','苗族','彝族','壮族','布依族','朝鲜族','满族','侗族','瑶族','白族','土家族','哈尼族','哈萨克族','傣族','黎族','僳僳族','佤族','畲族','高山族','拉祜族','水族','东乡族','纳西族','景颇族','柯尔克孜族', '土族','达斡尔族','仫佬族','羌族','布朗族','撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族','怒族','乌孜别克族','俄罗斯族','鄂温克族','德昂族','保安族','裕固族','京族','塔塔尔族','独龙族','鄂伦春族','赫哲族','门巴族','珞巴族','基诺族','其他'],
        cos:undefined,
      }
    },
    mounted(){
      console.info(ClipboardJS);
      new ClipboardJS('.copy-btn');
      this.cos= new COS({
        SecretId: 'AKIDxjGfqnHyINDsLauNuLXT9a8d7UAi3JL9',
        SecretKey: 'oTtxsa4II7h1ELI1UjncGo8F8mCQRDZq',
      })
      if (!this.assistance.theCase) this.assistance.img1 ="";
      if (!this.assistance.img1) this.assistance.img1 =undefined;
      if (!this.assistance.img2) this.assistance.img2 =undefined;
      if (!this.assistance.img3) this.assistance.img3 =undefined;
      if (!this.assistance.img4) this.assistance.img4 =undefined;
      if (!this.assistance.img5) this.assistance.img5 =undefined;
      this.assistance.applyId = this.assistance.id
    },
    methods:{
      showImage(imgUrl){
        this.overlayImageUrl =imgUrl;
        this.showImageOverlay =true;
      },
      afterRead(file,fileName){
        this.$store.commit('showOverlay');
        let appImg = file.file.name.substr(file.file.name.lastIndexOf('.'));
        this.cos.putObject({
          Bucket: 'jtfy-1301652109', /* 必须 */
          Region: 'ap-beijing',     /* 存储桶所在地域，必须字段 */
          Key: `/flyz/${fileName}-[${Math.floor(Math.random()*1000000000)}]${appImg}`,              /* 必须 */
          StorageClass: 'STANDARD',
          Body: file.file, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          }
        }, (err, data)=> {
          if(data&&data.statusCode===200){
            this.assistance[fileName] = 'https://'+data.Location
          }else {
            Toast.fail('上传申请表失败');
          }
          this.$store.commit('hideOverlay');
        });
      },
      afterReadAppendix(file){
        this.$store.commit('showOverlay');
        let appImg = file.file.name.substr(file.file.name.lastIndexOf('.'));
        this.cos.putObject({
          Bucket: 'jtfy-1301652109', /* 必须 */
          Region: 'ap-beijing',     /* 存储桶所在地域，必须字段 */
          Key: `/flyz/appendix-[${Math.floor(Math.random()*1000000000)}]${appImg}`,              /* 必须 */
          StorageClass: 'STANDARD',
          Body: file.file, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          }
        }, (err, data)=> {
          if(data&&data.statusCode===200){
            for (let name of ["img1","img2","img3","img4","img5"]){
              if (!this.assistance[name]) {
                this.assistance[name] = 'https://'+data.Location
                this.appendix=[]
                break;
              }
            }

          }else {
            Toast.fail('上传资料失败');
          }
          this.$store.commit('hideOverlay');
        });
      },
      appendixClearClick(index){
        console.info(index);
        console.info("img1:"+this.assistance.img1)
        console.info("img2:"+this.assistance.img2)
        console.info("img3:"+this.assistance.img3)
        console.info("img4:"+this.assistance.img4)
        console.info("img5:"+this.assistance.img5)
        if (index===5){
          this.assistance.img5=undefined
        } else if(index ===4 ){
          this.assistance.img4 =this.assistance.img5;
          this.assistance.img5 = undefined;
        }else if(index ===3 ){
          this.assistance.img3= this.assistance.img4
          this.assistance.img4 =this.assistance.img5;
          this.assistance.img5 = undefined;
        }else if(index ===2 ){
          this.assistance.img2= this.assistance.img3
          this.assistance.img3= this.assistance.img4
          this.assistance.img4 =this.assistance.img5;
          this.assistance.img5 = undefined;
        }else if(index ===1 ){
          this.assistance.img1 = this.assistance.img2
          this.assistance.img2= this.assistance.img3
          this.assistance.img3= this.assistance.img4
          this.assistance.img4 =this.assistance.img5;
          this.assistance.img5 = undefined;
        }
        this.$forceUpdate()
        console.info(this.assistance)
      },

      deleteImageAppendix(){
        for (let name of ["img5","img4","img3","img1","img1"]){
          if (this.assistance[name]) {
            this.assistance[name] = undefined;
            break;
          }
        }
      },
      idCardValidator(val){
        if(!val){
          return false
        }
        return  this.idCard18Pattern.test(val)||this.idCard15Pattern.test(val);
      },

      onClickLeft() {
        this.$router.back();
      },

      onPickNational(value){
        this.assistance.national = value;
        this.showNationalPicker = false;
      },
      onPickBirthDay(date){
        this.assistance.birthday = moment(date).format("YYYY-MM-DD");
        this.showBirthDayPicker = false
      },

      deleteImage(fileName){
        //删除oss上照片
        this.assistance[fileName] == undefined;
      },
      uploadImage(){
      },
      async submit(){
        try {
          await this.$refs['basicInfoForm'].validate();
          if (!this.assistance.idCardImgA){
            Toast.fail('请上传身份证正面照片')
            return
          }

          if (!this.assistance.idCardImgB){
            Toast.fail('请上传身份证背面照片')
            return
          }

          let response = await axios.post(`/fyserve/apply/edit?applyId=${this.assistance.id}`,this.assistance);
          let data = response.data;
          if (data.code === responseCodes.success) {
			 localStorage.setItem("currentAssistance",JSON.stringify(this.assistance))
            this.$router.back();
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
        }
      },
    }
  }
</script>

<style scoped>

</style>